module.exports = __webpack_public_path__ + "img/room14.ee88ad5a.gif";